/**
 * Helpers for "Show more" / expand logic in markdown messages:
 * detect the key question (last bold segment ending with ?**) so we never truncate in the middle of it.
 */

/** Last bold segment **...** in the content. */
export function getLastBoldSegment(content: string): { start: number; end: number } | null {
  const regex = /\*\*([\s\S]*?)\*\*/g
  let match: RegExpExecArray | null
  let last: { start: number; end: number } | null = null
  while ((match = regex.exec(content)) !== null) {
    last = { start: match.index, end: match.index + match[0].length }
  }
  return last
}

/** Whether the segment is the key question: at end of message and ends with ?** */
export function isKeyQuestion(content: string, start: number, end: number): boolean {
  const afterSegment = content.slice(end).trim()
  if (afterSegment.length > 0) return false
  const segmentContent = content.slice(start, end)
  return segmentContent.endsWith('?**')
}
